import Flickity from "flickity";

class Carousel {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.carousel = self.elem.querySelector('[data-carousel]');
        self.slideCounter = self.elem.querySelector('[data-slide-counter]');
        self.cellAlignment = self.elem.getAttribute('data-cell-alignment');
    }

    init() {
        let self = this;

        // Flickity options
        let flktyOptions = {
            contain: true,
            draggable: true,
            wrapAround: true,
            pageDots: true,
            prevNextButtons: false,
            autoPlay: 4000,
            cellAlign: self.cellAlignment ?? 'center',
        };

        // Initialise Flickity
        const flkty = new Flickity(self.carousel, flktyOptions);

        // Update the slide count
        const updateSlideCount = () => {
            const slideIndex = flkty.selectedIndex + 1;
            
            self.slideCounter.textContent = slideIndex;
        };
        
        // Listen for the select event
        flkty.on('select', updateSlideCount);
        
        // Initialize the slide count on load
        updateSlideCount();
    }
}

export default Carousel;
